<template>
    <div class="account bg_white">
        <div class="fl txt_black54 f18 bold500">
            <span class="bold600">账户名：</span>
            <span v-text="account"></span>
        </div>
        <div class="fl txt_black54 f18 bold500">
            <span class="bold600">名称：</span>
            <span v-text="name"></span>
        </div>
        <div class="fl txt_black54 f18 bold500">
            <span class="bold600">电话：</span>
            <span v-text="phone"></span>
        </div>
        <div class="fl txt_black54 f18 bold500">
            <span class="bold600">证件号码：</span>
            <span v-text="ID"></span>
        </div>
        <div class="fl txt_black54 f18 bold500">
            <span class="bold600">代理商：</span>
            <span v-text="account_withdraw"></span>
        </div>
        <div class="fl txt_black54 f18 bold500">
            <span class="bold600">账户余额：</span>
            <span v-text="balance"></span>
        </div>
        <div class="fl txt_black54 f18 bold500">
            <span class="bold600">类型：</span>
            <span v-text="type"></span>
        </div>
        <div class="fl txt_black54 f18 bold500">
            <span class="bold600">备注：</span>
            <span v-text="note"></span>
        </div>
        <div class="fl">
            <button class="bg_E91E63 f18 bold400 txt_white tc cursor_pointer" @click="changEvent">修改密码</button>
        </div>

    </div>
</template>

<script>
    export default {
        name: "account",
        data() {
            return {
                account: '代理商的账户名',
                name: '代理商姓名',
                phone: '18782119823',
                ID: '1231231222311232132',
                account_withdraw: '1231231222311232132',
                balance: 100,
                type: '代理',
                note: '代理商的备注'
            }
        },
        methods: {
            init() {

            },
            changEvent() {

            }
        }
    }
</script>

<style scoped>
    .account{
        width: 1000px;
        height: 600px;
    }
    .account>div{
        width: 440px;
        margin: 40px 0 0 40px;
    }
    .account>div>span:nth-of-type(1){
        width: 90px;
        display: inline-block;
    }
    .account>div>button{
        width: 200px;
        height: 36px;
        line-height: 36px;
        border-radius: 3px;
    }
</style>